import { getProFlowRouteNaming } from '../utils/stringUtils';
import store from '../store/redux/store';
import { CreateFlowPayload } from '../../../flows/src/types/ApiTypes';
import useAuth from '../../../app/src/features/authentication/hooks/useAuth';
import { getConversationById } from '../../../conversations/src/features/detail/shared/api/getConversationById';
import cogoToast from 'cogo-toast';
import { useTranslation } from 'react-i18next';
import usePartyId from '../../../common/src/hooks/query-params/usePartyId';
import { isEmpty } from 'lodash';

const EXCLUDED_COMPANIES = ['fidea'];

interface LouiseFlowQueryParams {
  getFlowPayload: (sessionId?: string) => Promise<CreateFlowPayload>;
}

const useSalesConversationFlowPayload = (): LouiseFlowQueryParams => {
  const { t } = useTranslation();
  const { campaign } = useAuth();
  const partyIdParam = usePartyId();

  const getFlowPayload = async (sessionId?: string) => {
    let {
      selectedCompanies,
      selectedRiskObjects,
      selectedGuarantees,
      partyId,
    } = store.getState().selection;

    if (
      (isEmpty(selectedCompanies) || isEmpty(selectedRiskObjects)) &&
      sessionId
    ) {
      try {
        const data = await getConversationById(sessionId);
        selectedCompanies = data.companies || [];
        selectedRiskObjects = data.insurance_types || [];
        selectedGuarantees = {
          car: data.car_tags || [],
          home: data.home_tags || [],
          legal: data.legal_tags || [],
          family: data.family_tags || [],
        };
      } catch (_) {
        cogoToast.error(t('Something went wrong'));
      }
    }

    if (!partyId) {
      partyId = partyIdParam;
    }

    return {
      company: selectedCompanies?.filter(
        (company) => !EXCLUDED_COMPANIES.includes(company),
      ),
      insurance_type: selectedRiskObjects.map((type) =>
        getProFlowRouteNaming(type),
      ),
      ...(partyId && { party_id: partyId }),
      ...(campaign?.short_id && { campaign_id: campaign?.short_id }),
      ...Object.assign(
        {},
        ...Object.entries(selectedGuarantees).map(
          ([riskObject, guarantees]) => ({
            [riskObject + '_tag']: guarantees,
          }),
        ),
      ),
    };
  };

  return { getFlowPayload };
};

export default useSalesConversationFlowPayload;
